import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { cleanupExpiredItems, cleanupDeprecatedKeys } from "./utils/storage";

// Nettoyage localStorage au démarrage (C1-StorageHygiene)
cleanupDeprecatedKeys();  // Supprime bodyup_lead_email et bodyup_avatar_sex
cleanupExpiredItems();    // Supprime les clés expirées (>12 mois)

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Retire l'écran de démarrage une fois React monté (fondu doux)
const splash = document.getElementById('splash-screen');
if (splash) {
  requestAnimationFrame(() => {
    setTimeout(() => {
      splash.style.opacity = '0';
      setTimeout(() => splash.remove(), 420);
    }, 250);
  });
}
